import OurClientAnimationBox from './OurClientAnimationBox';
export default function OurClientList({ clients }) {
  return (
    <div>
      <div
        className=" animation-container gap-4 xsm:gap-6 msm:gap-8 lgsm:gap-12 sm:gap-[12px] md:gap-12 md-x-lg:gap-[12px] lg:gap-4 xl:gap-12
                grid grid-cols-1  sm:grid-cols-2 md-x-lg:grid-cols-3 lg:grid-cols-3  " >
        {clients.map((clients, index) => {
          return (
            <OurClientAnimationBox {...clients} key={index} index={index} />
          )
        }
        )
        }
      </div>
    </div>
  )
}
